import * as yup from 'yup'

import { PHONE_REGEXP } from '../../../core/constants'

export const profileSchema = yup.object().shape({
  companyName: yup.string().required('Обязательное поле'),
  cashbackPercent: yup
    .number()
    .moreThan(0, 'Размер кешбека должен быть больше 0')
    .max(100, 'Размер кешбека не может превышать 100%')
    .required('Обязательное поле'),
  address: yup.string().nullable(),
  phone: yup
    .string()
    .trim()
    .matches(PHONE_REGEXP, 'Не правильный формат телефона')
    .nullable(),
  website: yup.string().nullable(),
  description: yup.string().nullable(),
  schedule: yup
    .array(
      yup.object().shape({
        day: yup
          .number()
          .integer()
          .required(),
        workingTimes: yup.string().required(),
      })
    )
    .nullable(),
})

export const businessSchema = profileSchema.shape({
  categories: yup
    .array(
      yup.object({
        id: yup
          .number()
          .integer()
          .required(),
      })
    )
    .min(1, 'Выберите категорию')
    .required('Выберите категорию'),
  coords: yup
    .array()
    .nullable()
    .test('coords-validation', '', value => {
      if (!value) return true
      const [lat, lng] = value

      if ((lat == null && lng != null) || (lat != null && lng == null)) {
        return new yup.ValidationError('Введите и широту, и долготу полностью', value, 'coords')
      }

      if (lat != null && (lat < -90 || lat > 90)) {
        return new yup.ValidationError('Широта должна быть от -90 до 90', value, 'coords')
      }

      if (lng != null && (lng < -180 || lng > 180)) {
        return new yup.ValidationError('Долгота должна быть от -180 до 180', value, 'coords')
      }

      return true
    }),
})
